import { buildModelManager } from "../builder.js";
const DefaultInstitutionConfigurationSelection = {
  __typename: true,
  id: true,
  accessCodeSystemEnabled: true,
  activeDocReaderSeats: true,
  allowStudentScenarioAccess: true,
  allowedDocumentTypes: true,
  attributionFooterText: true,
  brandingSettings: true,
  cohortManagementEnabled: true,
  complianceSettings: true,
  configuredById: true,
  contactInformation: true,
  createdAt: true,
  customFieldDefinitions: true,
  defaultScenarioLimit: true,
  defaultShiftTypes: true,
  documentRetentionPolicyDays: true,
  enableCalendarIntegration: true,
  enableClinicalQuickNotes: true,
  enableEducationalContentLibrary: true,
  enableEncounterVerification: true,
  enableEnhancedScenarios: true,
  enableFisdapShiftProcessing: true,
  enableFormsLibrary: true,
  enablePatientEncounterTracking: true,
  enablePhiDetection: true,
  enablePreceptorEvaluations: true,
  enablePreceptorScoring: true,
  enableScenarioDebriefAudio: true,
  enableScenarioGenerator: true,
  enableShiftScheduling: true,
  enableStudentScenarioEvals: true,
  enableVarianceDetection: true,
  evaluationFormTypes: true,
  fisdapInstitutionSettings: true,
  formQrCodeExpirationMinutes: true,
  formQrCodeSettings: true,
  institution: true,
  institutionUnlimitedScenarios: true,
  institutionalLogo: { url: true, mimeType: true, fileName: true },
  lastModifiedById: true,
  licenseAcceptanceRequired: true,
  notifyInstructorsOnFailedAudit: true,
  notifyInstructorsOnPassedAudit: true,
  notifyStudentsOnFailedAudit: true,
  notifyStudentsOnPassedAudit: true,
  purchasedSeats: true,
  qrCodeLocations: true,
  qrCodesEnabled: true,
  requirePreceptorApproval: true,
  requiredDocumentationLevel: true,
  scenarioGeneratorInstructorPermissions: true,
  scenariosUsedThisYear: true,
  schedulingPermissions: true,
  studentEvalViewingEnabled: true,
  subscriptionTier: true,
  timezone: true,
  totalDocReaderSeats: true,
  trackScenarioUsage: true,
  unlimitedScenarios: true,
  updatedAt: true,
  usedSeats: true,
  watermarkBackgroundText: true,
  watermarkIntensity: true,
  watermarkingEnabled: true,
  workflowSettings: true
};
const modelApiIdentifier = "institutionConfiguration";
const pluralModelApiIdentifier = "institutionConfigurations";
;
;
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultInstitutionConfigurationSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultInstitutionConfigurationSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultInstitutionConfigurationSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultInstitutionConfigurationSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultInstitutionConfigurationSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultInstitutionConfigurationSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultInstitutionConfigurationSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findByInstitution",
    findByField: "institution",
    findByVariableName: "institution",
    modelApiIdentifier,
    defaultSelection: DefaultInstitutionConfigurationSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindByInstitution",
    findByField: "institution",
    findByVariableName: "institution",
    modelApiIdentifier,
    defaultSelection: DefaultInstitutionConfigurationSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createInstitutionConfiguration",
    operationReturnType: "CreateInstitutionConfiguration",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      institutionConfiguration: { required: false, type: "CreateInstitutionConfigurationInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultInstitutionConfigurationSelection
  },
  {
    type: "action",
    operationName: "bulkCreateInstitutionConfigurations",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkCreateInstitutionConfigurationsInput!]"
      }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultInstitutionConfigurationSelection
  },
  {
    type: "action",
    operationName: "updateInstitutionConfiguration",
    operationReturnType: "UpdateInstitutionConfiguration",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      institutionConfiguration: { required: false, type: "UpdateInstitutionConfigurationInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultInstitutionConfigurationSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateInstitutionConfigurations",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkUpdateInstitutionConfigurationsInput!]"
      }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultInstitutionConfigurationSelection
  },
  {
    type: "action",
    operationName: "deleteInstitutionConfiguration",
    operationReturnType: "DeleteInstitutionConfiguration",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteInstitutionConfigurations",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "createCohortInstitutionConfiguration",
    operationReturnType: "CreateCohortInstitutionConfiguration",
    functionName: "createCohort",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      institutionConfiguration: {
        required: false,
        type: "CreateCohortInstitutionConfigurationInput"
      },
      cohortName: { required: false, type: "String" },
      cohortDisplayName: { required: false, type: "String" },
      cohortType: { required: false, type: "String" },
      academicYear: { required: false, type: "String" },
      startDate: { required: false, type: "String" },
      endDate: { required: false, type: "String" },
      description: { required: false, type: "String" },
      maxStudents: { required: false, type: "Float" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [
      "cohortName",
      "cohortDisplayName",
      "cohortType",
      "academicYear",
      "startDate",
      "endDate",
      "description",
      "maxStudents"
    ],
    hasReturnType: true,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultInstitutionConfigurationSelection
  },
  {
    type: "action",
    operationName: "bulkCreateCohortInstitutionConfigurations",
    functionName: "bulkCreateCohort",
    isBulk: true,
    isDeleter: false,
    hasReturnType: true,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "createCohort",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkCreateCohortInstitutionConfigurationsInput!]"
      }
    },
    paramOnlyVariables: [
      "cohortName",
      "cohortDisplayName",
      "cohortType",
      "academicYear",
      "startDate",
      "endDate",
      "description",
      "maxStudents"
    ],
    defaultSelection: DefaultInstitutionConfigurationSelection
  },
  {
    type: "action",
    operationName: "updateScenarioSettingsInstitutionConfiguration",
    operationReturnType: "UpdateScenarioSettingsInstitutionConfiguration",
    functionName: "updateScenarioSettings",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      institutionConfiguration: {
        required: false,
        type: "UpdateScenarioSettingsInstitutionConfigurationInput"
      },
      enableScenarioGenerator: { required: false, type: "Boolean" },
      enableStudentScenarioEvals: { required: false, type: "Boolean" },
      institutionUnlimitedScenarios: { required: false, type: "Boolean" },
      defaultScenarioLimit: { required: false, type: "Float" },
      enableEnhancedScenarios: { required: false, type: "Boolean" },
      enableScenarioDebriefAudio: { required: false, type: "Boolean" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [
      "enableScenarioGenerator",
      "enableStudentScenarioEvals",
      "institutionUnlimitedScenarios",
      "defaultScenarioLimit",
      "enableEnhancedScenarios",
      "enableScenarioDebriefAudio"
    ],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultInstitutionConfigurationSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateScenarioSettingsInstitutionConfigurations",
    functionName: "bulkUpdateScenarioSettings",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "updateScenarioSettings",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkUpdateScenarioSettingsInstitutionConfigurationsInput!]"
      }
    },
    paramOnlyVariables: [
      "enableScenarioGenerator",
      "enableStudentScenarioEvals",
      "institutionUnlimitedScenarios",
      "defaultScenarioLimit",
      "enableEnhancedScenarios",
      "enableScenarioDebriefAudio"
    ],
    defaultSelection: DefaultInstitutionConfigurationSelection
  },
  {
    type: "action",
    operationName: "upsertInstitutionConfiguration",
    operationReturnType: "UpsertInstitutionConfiguration",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      institutionConfiguration: { required: false, type: "UpsertInstitutionConfigurationInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateInstitutionConfigurationResult": { hasReturnType: false },
      "... on UpdateInstitutionConfigurationResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultInstitutionConfigurationSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertInstitutionConfigurations",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkUpsertInstitutionConfigurationsInput!]"
      }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultInstitutionConfigurationSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "institutionConfigurationGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const InstitutionConfigurationManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultInstitutionConfigurationSelection,
  operations
);
export {
  DefaultInstitutionConfigurationSelection,
  InstitutionConfigurationManager
};
//# sourceMappingURL=InstitutionConfiguration.js.map
